import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@components';
import { NotificationPreferencesForm } from '../types';

interface NotificationsTabProps {
  notifications: NotificationPreferencesForm;
  onUpdateNotifications: (updates: Partial<NotificationPreferencesForm>) => void;
}

export const NotificationsTab: React.FC<NotificationsTabProps> = ({
  notifications,
  onUpdateNotifications,
}) => {
  const { t } = useTranslation();
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>{t('profile.notificationPreferences')}</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
                  {t('profile.emailNotifications')}
                </h3>
                <div className="space-y-4">
                  <div className="flex items-center">
                    <input
                      id="emailLogin"
                      type="checkbox"
                      checked={notifications.emailLogin}
                      onChange={e => onUpdateNotifications({ emailLogin: e.target.checked })}
                      className="mr-3 h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
                    />
                    <label
                      htmlFor="emailLogin"
                      className="text-sm font-medium text-gray-700 dark:text-gray-300"
                    >
                      {t('profile.loginNotifications')}
                    </label>
                  </div>
                  <div className="flex items-center">
                    <input
                      id="emailSecurity"
                      type="checkbox"
                      checked={notifications.emailSecurity}
                      onChange={e => onUpdateNotifications({ emailSecurity: e.target.checked })}
                      className="mr-3 h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
                    />
                    <label
                      htmlFor="emailSecurity"
                      className="text-sm font-medium text-gray-700 dark:text-gray-300"
                    >
                      {t('profile.securityAlerts')}
                    </label>
                  </div>
                  <div className="flex items-center">
                    <input
                      id="emailUpdates"
                      type="checkbox"
                      checked={notifications.emailUpdates}
                      onChange={e => onUpdateNotifications({ emailUpdates: e.target.checked })}
                      className="mr-3 h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
                    />
                    <label
                      htmlFor="emailUpdates"
                      className="text-sm font-medium text-gray-700 dark:text-gray-300"
                    >
                      {t('profile.systemUpdates')}
                    </label>
                  </div>
                  <div className="flex items-center">
                    <input
                      id="emailMarketing"
                      type="checkbox"
                      checked={notifications.emailMarketing}
                      onChange={e => onUpdateNotifications({ emailMarketing: e.target.checked })}
                      className="mr-3 h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
                    />
                    <label
                      htmlFor="emailMarketing"
                      className="text-sm font-medium text-gray-700 dark:text-gray-300"
                    >
                      {t('profile.marketingCommunications')}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
                  {t('profile.smsNotifications')}
                </h3>
                <div className="space-y-4">
                  <div className="flex items-center">
                    <input
                      id="smsLogin"
                      type="checkbox"
                      checked={notifications.smsLogin}
                      onChange={e => onUpdateNotifications({ smsLogin: e.target.checked })}
                      className="mr-3 h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
                    />
                    <label
                      htmlFor="smsLogin"
                      className="text-sm font-medium text-gray-700 dark:text-gray-300"
                    >
                      {t('profile.loginNotifications')}
                    </label>
                  </div>
                  <div className="flex items-center">
                    <input
                      id="smsSecurity"
                      type="checkbox"
                      checked={notifications.smsSecurity}
                      onChange={e => onUpdateNotifications({ smsSecurity: e.target.checked })}
                      className="mr-3 h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
                    />
                    <label
                      htmlFor="smsSecurity"
                      className="text-sm font-medium text-gray-700 dark:text-gray-300"
                    >
                      {t('profile.securityAlerts')}
                    </label>
                  </div>
                  <div className="flex items-center">
                    <input
                      id="smsUpdates"
                      type="checkbox"
                      checked={notifications.smsUpdates}
                      onChange={e => onUpdateNotifications({ smsUpdates: e.target.checked })}
                      className="mr-3 h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
                    />
                    <label
                      htmlFor="smsUpdates"
                      className="text-sm font-medium text-gray-700 dark:text-gray-300"
                    >
                      {t('profile.systemUpdates')}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
